/* ============
 * SMS Two Factor Authentication
 * ============
 *
 * This is the page for two factor auth.
 */
import { mapGetters, mapMutations } from 'vuex';
import smsTwoFactorAuthService from '../../services/smsTwoFactorAuthSetup';
import modulesService from './../../services/modules';


export default {
  props: {
    module: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      sms2faEnabled: false,
      verificationSent: false,
      mobileNumber: null,
      twoFactorAuthToken: null,
      twoFactorTimerCount: null,
      verified: false,
      loading: false,
      sendLoading: false,
      verifyLoading: false,
    };
  },

  computed: {
    ...mapGetters({
      account: 'account',
      modules: 'allModules',
    }),

    isGoogle2faEnabled() {
      return this.modules.find(module => (module.name === 'Google Two-Factor Authentication' && module.subscribe));
    },
  },

  watch: {
    twoFactorTimerCount: {
      handler(value) {
        if (value > 0) {
          setTimeout(() => {
            this.twoFactorTimerCount--;
          }, 1000);
        }
      },
      immediate: true, // This ensures the watcher is triggered upon creation
    },
  },

  methods: {
    ...mapMutations({
      toggle: 'TOGGLE_MODAL',
      unsetModalContent: 'UNSET_MODAL_CONTENT',
    }),
    /**
     * This method will be called when saving the form.
     */
    sendVerificationToken() {
      const mobile = `+47${this.mobileNumber}`;
      if (!this.verifyMobileNumber(mobile)) {
        this.$message({
          message: this.$t('static.smsTwoFactorVerification.invalidMobileNumber'),
          type: 'error',
        });
        return;
      }

      this.sendLoading = true;
      const data = {
        mobile_number: mobile,
        user_id: this.account.userId,
        module_id: this.module.id,
      };
      Promise.resolve(smsTwoFactorAuthService.sendVerificationToken(data))
      .then(() => {
        this.sendLoading = false;
        this.verificationSent = true;
        this.twoFactorTimerCount = 30;
        this.$message({
          message: this.$t('static.smsTwoFactorVerification.verificationCodeSent'),
          type: 'success',
        });
      })
      .catch((errors) => {
        if ('mobile_number' in errors) {
          this.$message({
            message: this.$t('static.smsTwoFactorVerification.invalidMobileNumber'),
            type: 'error',
          });
        }
        this.$message({
          message: this.$t('static.smsTwoFactorVerification.unableToSendVerification'),
          type: 'error',
        });
        this.twoFactorTimerCount = 0;
        this.sendLoading = false;
      });
    },

    /**
     * This method will be called when saving the form.
     */
    verifyToken() {
      if (!this.twoFactorAuthToken) {
        this.$message({
          message: this.$t('static.smsTwoFactorVerification.verificationCodeIncorrect'),
          type: 'error',
        });
        return;
      }
      this.verifyLoading = true;
      const data = {
        code: this.twoFactorAuthToken,
        user_id: this.account.userId,
        module_id: this.module.id,
      };
      Promise.resolve(smsTwoFactorAuthService.verifyToken(data))
      .then(() => {
        this.verifyLoading = false;
        this.verified = true;
        modulesService.items().then(() => {
          this.$message({
            message: this.$t('static.smsTwoFactorVerification.smsTwoFactorAuthEnabled'),
            type: 'success',
          });
          this.closeModal();
        });
      })
      .catch((errors) => {
        this.verifyLoading = false;
        if ('mobile_number' in errors) {
          this.$message({
            message: this.$t('static.smsTwoFactorVerification.requiredMobileNumber'),
            type: 'error',
          });
          this.twoFactorTimerCount = 0;
        }
        this.$message({
          message: this.$t('static.smsTwoFactorVerification.verificationCodeIncorrect'),
          type: 'error',
        });
      });
    },

    verifyMobileNumber(mobile) {
      const regex = /^(0047|\+47|47)?[2-9]\d{7}$/;
      return regex.test(mobile);
    },
    /*
     * Closes the modal
     */
    closeModal() {
      this.toggle(false);
      this.unsetModalContent();
    },
  },
};



// WEBPACK FOOTER //
// ./src/app/components/smsTwoFactorAuthSetup/smsTwoFactorAuthSetup.js